import Button from '@mui/material/Button'
import MuiLink from '@mui/material/Link'
import MenuItem from '@mui/material/MenuItem'
import MuiTextField from '@mui/material/TextField'
import { createLink } from '@tanstack/react-router'
import type { ComponentProps } from 'react'

export const LinkButton = createLink(Button)
export const Link = createLink(MuiLink)
export const NavMenuItem = createLink(MenuItem)
export const TextField = (props: ComponentProps<typeof MuiTextField>) => (
	<MuiTextField slotProps={{ select: { MenuProps: { color: 'secondary' } } }} {...props} />
)

export { default as Accordion } from '@mui/material/Accordion'
export { default as AccordionDetails } from '@mui/material/AccordionDetails'
export { default as AccordionSummary } from '@mui/material/AccordionSummary'
export { default as Alert } from '@mui/material/Alert'
export { default as AlertTitle } from '@mui/material/AlertTitle'
export { createFilterOptions, default as Autocomplete } from '@mui/material/Autocomplete'
export { default as Avatar } from '@mui/material/Avatar'
export { default as Backdrop } from '@mui/material/Backdrop'
export { default as Button } from '@mui/material/Button'
export { default as ButtonBase } from '@mui/material/ButtonBase'
export { default as ButtonGroup } from '@mui/material/ButtonGroup'
export { default as Checkbox } from '@mui/material/Checkbox'
export { default as Chip } from '@mui/material/Chip'
export { default as CircularProgress } from '@mui/material/CircularProgress'
export { default as ClickAwayListener } from '@mui/material/ClickAwayListener'
export { default as Collapse } from '@mui/material/Collapse'
export { default as Dialog } from '@mui/material/Dialog'
export { default as DialogActions } from '@mui/material/DialogActions'
export { default as DialogContent } from '@mui/material/DialogContent'
export { default as DialogTitle } from '@mui/material/DialogTitle'
export { default as Divider } from '@mui/material/Divider'
export { default as Drawer } from '@mui/material/Drawer'
export { default as Fade } from '@mui/material/Fade'
export { default as FormControl } from '@mui/material/FormControl'
export { default as FormControlLabel } from '@mui/material/FormControlLabel'
export { default as FormGroup } from '@mui/material/FormGroup'
export { default as FormHelperText } from '@mui/material/FormHelperText'
export { default as FormLabel } from '@mui/material/FormLabel'
export { default as Grid } from '@mui/material/Grid'
export { default as MuiIconButton } from '@mui/material/IconButton'
export { default as InputAdornment } from '@mui/material/InputAdornment'
export { default as InputLabel } from '@mui/material/InputLabel'
export { default as LinearProgress } from '@mui/material/LinearProgress'
export { default as MuiLink } from '@mui/material/Link'
export { default as List } from '@mui/material/List'
export { default as ListItem } from '@mui/material/ListItem'
export { default as ListItemButton } from '@mui/material/ListItemButton'
export { default as ListItemIcon } from '@mui/material/ListItemIcon'
export { default as ListItemText } from '@mui/material/ListItemText'
export { default as Menu } from '@mui/material/Menu'
export { default as MenuItem } from '@mui/material/MenuItem'
export { default as Paper } from '@mui/material/Paper'
export { default as Popover } from '@mui/material/Popover'
export { default as Popper } from '@mui/material/Popper'
export { default as Radio } from '@mui/material/Radio'
export { default as RadioGroup } from '@mui/material/RadioGroup'
export { default as Select } from '@mui/material/Select'
export { default as Slide } from '@mui/material/Slide'
export { default as Snackbar } from '@mui/material/Snackbar'
export { default as Step } from '@mui/material/Step'
export { default as StepContent } from '@mui/material/StepContent'
export { default as StepLabel } from '@mui/material/StepLabel'
export { default as Stepper } from '@mui/material/Stepper'
export { default as Switch } from '@mui/material/Switch'
export { default as Tab } from '@mui/material/Tab'
export { default as Tabs } from '@mui/material/Tabs'
export { default as ToggleButton } from '@mui/material/ToggleButton'
export { default as ToggleButtonGroup } from '@mui/material/ToggleButtonGroup'
export { default as Tooltip } from '@mui/material/Tooltip'
export { default as Typography } from '@mui/material/Typography'
